import React from 'react';
import { useTheme } from 'styled-components/native';
import Icon from 'react-native-vector-icons/dist/MaterialCommunityIcons';
import { useGeolocation } from '../hooks';
import * as S from './styles';
import { GeolocationButtonProps } from './types';
import { Button, Typography } from '~/components/@hello-ui';
import IconGeolocation from '../../../../../assets/icons/geolocation.svg';


export const GeolocationButton = ({ color }: GeolocationButtonProps): JSX.Element => {
  const theme = useTheme();
  const { getGeolocationAddress } = useGeolocation();

  return (
    <> 
      <Button
        variant="outline"
        icon={<IconGeolocation width={30} height={30} />}
        onPress={() => getGeolocationAddress(color)}
        textStyle={{ fontSize: 16 }}
      >
        Usar localização atual
      </Button>
    </>
    
  );
};